import React from 'react'
import { Card, CardHeader, CardTitle, CardBody } from 'reactstrap'

const History = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle tag='h4'>Progress Assessment History</CardTitle>
      </CardHeader>
      <CardBody>
        <div className='history-container'>
          {/* Add your history content here */}
          <p>Progress assessment history will be displayed here.</p>
        </div>
      </CardBody>
    </Card>
  )
}

export default History 